/* eslint-disable */
import React from "react";
import HelpCenter from "../../components/HelpCenter/HelpCenter";

export default function TopicsPage() {
  return <HelpCenter />;
}
